import { IconsProps } from '@/types/shared'

const ArrowRightIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15 18L24 9L15 0L12.9 2.175L18.225 7.5H0V10.5H18.225L12.9 15.825L15 18Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default ArrowRightIcons
